import React from 'react';

import { OrganogramModel } from '../../../../../Models/OrganogramModel';
import { EditAction } from '../../../../../shared/enum/EditAction';
import { CutoutOrganogramAccordionItem } from './CutoutOrganogramAccordionItem';
export interface ICutoutOrganogramListProps {
    listOrg: OrganogramModel[],
    parent: number | null,
    level: number,
    textLevel: string,
}

export function CutoutOrganogramList({ listOrg, parent, level, textLevel }: ICutoutOrganogramListProps) {
    const items = listOrg.filter(x => x.parentId == parent);

    return (
        <>
            {items.map((organogram) => {
                const childrens = listOrg.filter(x => organogram.id === x.parentId);
                const isParent = childrens.length > 0;

                if (organogram.editAction != EditAction.DELETE)
                    return (
                        <CutoutOrganogramAccordionItem
                            key={organogram.id}
                            organogram={organogram}
                            textLevel={textLevel}
                            isParent={isParent}
                            level={level}
                            listOrg={listOrg}
                        />
                    );
            })}
        </>
    );
}